import React, { useEffect, useState } from "react";
import "./Legal_notice.css";
import {
  faClipboardQuestion,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import Contact_details_card from "../../common_components/contact_details_card/Contact_details_card";
import { luxuryLegalNotice } from "../../../utils/luxuryapis/Home/Homeapi";

function Legal_notice() {
  const [legalnotice, setLegalNotice] = useState([]);
  console.log(legalnotice, "legalnoticelegalnotice");

  const getAllLuxuryLegalNotice = async () => {
    const res = await luxuryLegalNotice();
    if (res?.success) {
      setLegalNotice(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryLegalNotice();
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <section className="Legal_notice">
        <div className="custom_container">
          <div className="row">
            <div className="col-md-8">
              <div className="content_box_holder">
                <div className="heading_strip_holder">
                  <h1>LEGAL NOTICE</h1>
                </div>
              </div>

              <div className="content_box_holder">
                <div className="content_holder">
                  <div className="text_holder">
                    {legalnotice.length > 0 ? (
                      legalnotice.map((item) => (
                        <div key={item.id}>
                          <p>
                            Last updated{" "}
                            {new Date(item.updatedAt).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "long",
                                year: "numeric",
                              },
                            )}
                          </p>

                          <h4>{item.name}</h4>
                          <hr />

                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        </div>
                      ))
                    ) : (
                      <p style={{ textAlign: "center", marginTop: "20px" }}>
                        No data found
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <Contact_details_card />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Legal_notice;
